'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

var _commons = require('../utils/commons');

var _DateField = require('./DateField');

var _DateField2 = _interopRequireDefault(_DateField);

var _TimeField = require('./TimeField');

var _TimeField2 = _interopRequireDefault(_TimeField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateTimeField = function (_PureComponent) {
    (0, _inherits3.default)(DateTimeField, _PureComponent);

    function DateTimeField(props) {
        (0, _classCallCheck3.default)(this, DateTimeField);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DateTimeField.__proto__ || (0, _getPrototypeOf2.default)(DateTimeField)).call(this, props));

        _this.handleDateChange = function (event) {
            var date = (0, _commons.localUTCToDate)(event.target.value);
            _this.setState({ date: date }, _this.propagateChange);
        };

        _this.handleTimeChange = function (value) {
            var time = (0, _commons.localUTCToTime)(value);
            _this.setState({ time: time }, _this.propagateChange);
        };

        _this.propagateChange = function () {
            var _this$props = _this.props,
                value = _this$props.value,
                onChange = _this$props.onChange;

            if (onChange) {
                var internalValue = _this.computeValueFromState();
                if (value !== internalValue) {
                    onChange(internalValue);
                }
            }
        };

        _this.focusBlur = new _utils.CompositeFocusBlur(_this);
        _this.state = _this.computeStateFromValue(props.value);
        return _this;
    }

    (0, _createClass3.default)(DateTimeField, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var value = this.props.value;

            if (value !== prevProps.value && value !== this.computeValueFromState()) {
                this.setState(this.computeStateFromValue(value));
            }
        }
    }, {
        key: 'computeStateFromValue',
        value: function computeStateFromValue(value) {
            return {
                date: (0, _commons.localUTCToDate)(value),
                time: (0, _commons.localUTCToTime)(value)
            };
        }
    }, {
        key: 'computeValueFromState',
        value: function computeValueFromState() {
            var _state = this.state,
                date = _state.date,
                time = _state.time;

            return date != null && time != null ? (0, _commons.dateTimeToLocalUTC)((0, _commons.combineDateTime)(date, time)) : '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                date = _state2.date,
                time = _state2.time;
            var disabled = this.props.disabled;


            return _react2.default.createElement(
                'div',
                { className: 'd-flex flex-row flex-nowrap' },
                _react2.default.createElement(_DateField2.default, (0, _extends3.default)({ value: (0, _commons.dateToLocalUTC)(date),
                    onChange: this.handleDateChange,
                    disabled: disabled
                }, this.focusBlur.handlers)),
                _react2.default.createElement(_TimeField2.default, (0, _extends3.default)({ value: (0, _commons.timeToLocalUTC)(time),
                    onChange: this.handleTimeChange,
                    disabled: disabled
                }, this.focusBlur.handlers))
            );
        }
    }]);
    return DateTimeField;
}(_react.PureComponent);

DateTimeField.propTypes = {
    value: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    onBlue: _propTypes2.default.func
};
exports.default = DateTimeField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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